import { 
    apiGetEditHouseList,
    apiInsertEditHouse,
    apiInsertHouseImage,
    apiDelHouseImage,
    apiDelHouse,
    apiPublishHouse,
    apiInsertEditHouseNoReview,
    apiBatchHouse
} from "@/apis/api.js"; 

import { 
    uploadVideo
} from "@/apis/landlord/houseMgt.js"; 

import router from '@/router'

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    get_house_default: 'editHouse/get_house_default',
    set_house_list: 'editHouse/set_house_list',
    set_image_files: 'editHouse/set_image_files',
    set_image_cover: 'editHouse/set_image_cover',
    set_video: 'editHouse/set_video',
    set_del_image: 'editHouse/set_del_image',
    set_del_cover: 'editHouse/set_del_cover',
    set_house_cid: 'editHouse/set_house_cid',
    set_house_policy: 'editHouse/set_house_policy',
    set_save_fail: 'editHouse/set_save_fail',
    set_save_success: 'editHouse/set_save_success',
    set_save_type: 'editHouse/set_save_type',
}

// count state 必須是 Object
const state = {
    savetype: 'REVEIW',
    houseDefaultList: [],
    houseList: [],
    imageFiles: [],
    cover: 0,
    covers: [],
    video: null,
    delImg: [],
    delCover: false,
    houseCid: '',
    error: {
        state: false,
        msg: '儲存失敗，請再試一次'
    },
    success: {
        state: false,
        msg: '下架成功'
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_EDIT_HOUSE_STATUS: (state) => {
        return state.houseDefaultList.houseStatus
    },
    GET_EDIT_FEATURES: (state) => {
        return state.houseDefaultList.features
    },
    GET_EDIT_EQUIPS: (state) => {
        return state.houseDefaultList.equips
    },
    GET_EDIT_RENT_INCLUDE: (state) => {
        return state.houseDefaultList.rentInclude
    },
    GET_EDIT_BUILDING_TYPE: (state) => {
        return state.houseDefaultList.buildingTypeList
    },
    GET_EDIT_HOUSE_TYPE: (state) => {
        return state.houseDefaultList.houseTypeList
    },
    GET_EDIT_SPECIAL_TYPE: (state) => {
        return state.houseDefaultList.specialTypeList
    },
    GET_EDIT_HOUSE_BILL_CHRAGE_MODE: (state) => {
        return state.houseDefaultList?state.houseDefaultList.billChargeMode:null
    },
    GET_EDIT_HOUSE_POLICY: (state) => {
        return state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList
    },
    GET_EDIT_DESPOSIT_POLICY: (state) => {
        return state.houseDefaultList.caseDepositPolicyDto.policySettingUseDtoList
    },
    GET_EDIT_HOUSE_DEFAULT: (state) => {
        return state.houseDefaultList.houseDataEditDto
    },
    GET_EDIT_ERROR_STATE: (state) => {
        return state.error
    },
    GET_EDIT_SUCCESS_STATE: (state) => {
        return state.success
    },
    GET_EDIT_HOUSE_COMPELETE: (state) => {
        return state.houseDefaultList.complete
    },
    GET_EDIT_HOUSE_PUBLISH: (state) => {
        return state.houseDefaultList.houseDataEditDto.publish
    },
    GET_EDIT_RENT_PERIOD_LIST: (state) => {
        return state.houseDefaultList.houseDataEditDto.rentPeriodList
    },
    GET_EDIT_HOUSE_HAS_IMAGE: (state) => {
        // console.log(state.delCover)
        // console.log(delCoverCount)
        let defaultImgCount = state.houseDefaultList.houseDataEditDto.houseImageListList?state.houseDefaultList.houseDataEditDto.houseImageListList.length:0
        let delImgCount = state.delImg.length
        let imgCount = defaultImgCount+ state.imageFiles.length
        // console.log(delImgCount)
        // console.log(defaultImgCount)
        if(delImgCount < imgCount){
            return true
        }else{
            return false
        }
    },
    GET_EDIT_HOUSE_HAS_COVER: (state) => {
        let cover = state.houseDefaultList.houseDataEditDto.houseCoverImage
      
        if(cover || state.covers.length > 0){
            return true
        }else{
            return false
        }
    },
    GET_EDIT_HOUSE_HAS_CHANGE_COVER: (state) => {
        let cover = state.houseDefaultList.houseDataEditDto.houseCoverImage
        let coverName = cover.split(/(\\|\/)/g).pop()
        if(coverName == 'default.png' && state.covers.length == 0){
            return false
        }else{
            return true
        }
    },
    GET_EDIT_HOUSE_MOVE_IN_DATE_START: (state) => {
        return state.houseDefaultList.houseDataEditDto.startDate
    },
    
}

// actions 也是以 Object 形式建構。
const actions = {
    getEditHouseDefault ( {commit, state} ) {
        return new Promise((resolve, reject) => {
            apiGetEditHouseList(state.houseCid)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result
                    commit(types.get_house_default, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getEditHousePolicy ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiGetEditHouseList(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.caseHousePolicyDto.policySettingUseDtoList
                    commit(types.set_house_policy, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setHouseCid ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_cid, data);
            resolve()
        })
    },
    setSaveType ({commit}, data) {
        return new Promise((resolve, reject) => {
            commit(types.set_save_type, data);
            resolve()
        })
    },
    setEditPublish( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            let obj = {
                "houseCid": state.houseCid,
                "status": data
            }
            apiPublishHouse(obj)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(data)
                    if(data == 'HIDE'){
                        commit(types.set_save_success, {status: true, msg: '下架成功'})
                        dispatch('getEditHouseDefault')
                    }
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setEditHouseList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_list, data);
            resolve()
        })
    },
    setEditImageFiles ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_files, data);
            resolve()
        })
    },
    setEditImageCovers ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_cover, data);
            resolve()
        })
    },
    setEditDelImage ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_del_image, data);
            resolve()
        })
    },
    setEditDelCover ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_del_cover, true);
            resolve()
        })
    },
    setEditCover ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_cover, data);
            resolve() 
        })
    },
    saveEditHouse ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiInsertEditHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        console.log('saveEditVideo')
                        dispatch('saveEditVideo', state.houseCid )
                        .then( () => {
                        })
                    }
                    dispatch('delEditCover')
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveEditHouseNoReview ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            // console.log(data)
            apiInsertEditHouseNoReview(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveEditVideo', state.houseCid )
                        .then( () => {
                        })
                    }
                    dispatch('delEditCover')
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    deleteEditHouse ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            // console.log(data)
            apiDelHouse(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveEditImage ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            console.log('上傳圖片張數:'+state.imageFiles.length)
            console.log(router.currentRoute)
            if(state.imageFiles.length > 0){
                console.log('SaveImg')
                    
                state.imageFiles.map( (image, index) => {
                    
                    let formData = new FormData();
                        formData.append('houseImage', image.file);
                        formData.append('houseCid', state.houseCid);
                        formData.append('imageSeq', '1');
                         for (var key of formData.keys()) {
                            console.log('content:'+key); 
                         }
                        for (var value of formData.values()) {
                            console.log('content:'+value); 
                         }
                    apiInsertHouseImage(formData)
                    .then(res => {
                        console.log(res)
                        // console.log(state.imageFiles.length)
                        // console.log(index+1)
                        if( index+1 == state.imageFiles.length){
                                // window.location.reload(); 
                                dispatch('setEditImageFiles', [])
                                if(state.saveType == 'REVIEW'){
                                    
                                    dispatch('setEditPublish', 'REVEAL')
                                    .then(() => {
                                        // router.push({ name: 'HouseManagementDefault'})
                                        dispatch('setLoadingState', 0)
                                        resolve()
                                    })
                                }else{
                                    // router.push({ name: 'HouseManagementDefault'})
                                    dispatch('setLoadingState', 0)
                                    resolve()
                                }
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
                })
            }else{
                console.log('noImg')
                if(state.saveType == 'REVIEW'){
                    dispatch('setEditPublish', 'REVEAL')
                    .then(() => {
                        // router.push({ name: 'HouseManagementDefault'})
                        dispatch('setLoadingState', 0)
                        resolve()
                    })
                }else{
                    console.log('123')
                    // router.push({ name: 'HouseManagementDefault'})
                    dispatch('setLoadingState', 0)
                    resolve()
                }
                    // window.location.reload(); 
            }
        })
    },
    saveEditCover ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            if(state.covers.length > 0){
                let formData = new FormData();
                    formData.append('housesCid', state.houseCid);
                    formData.append('headImage', state.covers[0].file);
                        
                    // for (var key of formData.keys()) {
                    //     console.log('cover:'+key); 
                    //  }
                    // for (var value of formData.values()) {
                    //     console.log('cover:'+value); 
                    //  }
                apiBatchHouse(formData)
                .then(res => {
                    // console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        dispatch('saveEditImage')
                        dispatch('setEditImageCovers', [])
                        resolve()
                    }else{
                        dispatch('setLoadingState', 0)
                        commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                    }
                })
                .catch(err => {
                    reject(err)
                })
            }else{
                dispatch('saveEditImage')
            }
        })
    },
    delEditImage ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(state.delImg.length > 0){
                console.log('DelImg')

                state.delImg.map( (image, index) => {
                    console.log(state.delImg.length)
                    console.log(index)
                    let data = '?imageCid='+image
                    console.log(data)
                    apiDelHouseImage(data)
                    .then(res => {
                        console.log(res)
                        if(res.data.status == "SUCCESS"){
                            if( index+1 == state.delImg.length){
                                dispatch('saveEditCover')
                                resolve()
                            }
                        }else{
                            dispatch('setLoadingState', 0)
                            commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                        }
                        
                    })
                    .catch(err => {
                        reject(err)
                    })
                })
            }else{
                console.log('noDelImg')
                dispatch('saveEditCover')
            }
            // dispatch('saveEditImage')
        })
    },
    delEditCover( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(state.delCover){
                console.log('delCover')
                let data = '?houseCid='+state.houseCid
                apiDelHouseImage(data)
                .then(res => {
                    // console.log(res)
                // console.log('delCoverAPI')

                    if( res.data.status == "SUCCESS" ){
                        // state.covers = []
                        dispatch('delEditImage')
                        resolve()
                    }else{
                        dispatch('setLoadingState', 0)
                        commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                    }
                })
                .catch(err => {
                    reject(err)
                })
            }else{
                console.log('noDelCover')
                dispatch('delEditImage')
            }
            // dispatch('saveEditImage')
        })
    },
    saveEditVideo ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
                console.log('saveEditVideo')
                let formData = new FormData();
            let houseCid = data,
            houseFilm = state.video.length?state.video[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseFilm', houseFilm);
            uploadVideo(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setEditVideo( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_video, data);
        })
    },
}

// mutations
const mutations = {
    [types.get_house_default](state, data){
        state.houseDefaultList = data
    },
    [types.set_house_list](state, data){
        state.houseList = data
    },
    [types.set_image_files](state, data){
        state.imageFiles = data
    },
    [types.set_image_cover](state, data){
        state.covers = data
    },
    [types.set_del_image](state, data){
        state.delImg = data
    },
    [types.set_del_cover](state, data){
        state.delCover = data
    },
    [types.set_video](state, data){
        state.video = data
    },
    [types.set_house_cid](state, data){
        state.houseCid = data
    },
    [types.set_house_policy](state, data){
        state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList = data
    },
    [types.set_save_fail](state, data){
        if(data.status){
            state.error.state = true
            state.error.msg = data.msg
        }else{
            state.error.state = false
            state.error.msg = ''
        }
        
    },
    [types.set_save_success](state, data){
        if(data.status){
            state.success.state = true
            state.success.msg = data.msg
        }else{
            state.success.state = false
            state.success.msg = ''
        }
    },
    [types.set_save_type](state, data){
        state.saveType = data
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/editHouse.js